<template>
  <IonicModal
    v-bind="attrs"
    :keep-contents-mounted="resolvedKeepContentsMounted"
    :css-class="resolvedCssClass"
  >
    <slot />
  </IonicModal>
</template>

<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import { IonModal as IonicModal, isPlatform } from '@ionic/vue'

defineOptions({
  inheritAttrs: false,
})

const attrs = useAttrs()
const isWebPanel = isPlatform('desktop') || isPlatform('mobileweb')

const resolvedKeepContentsMounted = computed(() => {
  const explicitValue = attrs.keepContentsMounted ?? attrs['keep-contents-mounted']

  if (explicitValue !== undefined) {
    return explicitValue === '' ? true : Boolean(explicitValue)
  }

  return isWebPanel
})

const resolvedCssClass = computed(() => {
  const explicitValue = attrs.cssClass ?? attrs['css-class']
  const classes = normalizeCssClass(explicitValue)

  if (isWebPanel) {
    classes.push('web-panel-modal')
  }

  return classes.length > 0 ? classes.join(' ') : undefined
})

function normalizeCssClass(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.flatMap(normalizeCssClass)
  }

  if (typeof value === 'string') {
    return value.split(/\s+/).filter(Boolean)
  }

  return []
}
</script>